module.exports = __webpack_public_path__ + "img/order-icon-3.e037c839.png";